export type Me = { id: string; email: string; created_at: string };

export type Mailbox = {
  id: string;
  local_part: string;
  display_name: string;
  apex: string;
  role: 'operator';
};

export type MessageSummary = {
  id: string;
  from: string;
  to: string[];
  subject: string;
  snippet: string;
  direction: 'inbound' | 'outbound';
  seen: boolean;
  archived: boolean;
  occurred_at: string;
};

export type MessageList = {
  data: MessageSummary[];
  before: string | null;
};

export type MessageDetail = MessageSummary & {
  cc: string[];
  body_text: string | null;
  body_html: string | null;
  in_reply_to: string | null;
  attachments: {
    id: string;
    filename: string;
    content_type: string;
    size_bytes?: number | null;
    url?: string | null;
  }[];
};

export type Envio = {
  to: string[];
  cc?: string[];
  subject: string;
  text: string;
  html?: string | null;
  in_reply_to?: string | null;
};

export class ErroApi extends Error {
  constructor(
    message: string,
    readonly status: number,
    readonly code?: string,
  ) {
    super(message);
    this.name = 'ErroApi';
  }
}

export function endereco(m: Mailbox): string {
  return `${m.local_part}@${m.apex}`;
}

export function inquilino(apex: string): string {
  if (apex === 'lizi.app.br') return 'Lizi';
  return 'Interludio';
}
